import Component from '../core/Component'

export default class CartOpener extends Component {

    prepare() {
        this.element.addEventListener('click', ::this.handleClick)
    }

    handleClick(event) {
        event.preventDefault()

        const cartSidebar = Component.getFromElement('cart-sidebar')

        if (cartSidebar) {
            cartSidebar.open()
        }
    }
}